import React from "react"

const DisclaimerCard = () => {
    return(
        <div className="card disclaimer">

            <p className="card-body disclaim">Disclaimer: <span className="disclaimer-text"> This is solely a suggestion tool. Prices noted on items are not of particular brands but are an estimation
                based on the variety of options in the broad market. None of the images are due to paid advertisement.
                </span></p>
        </div>
    )
}

export default DisclaimerCard